"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebSocketUrlBuilderImpl = void 0;
const format_util_1 = __importDefault(require("format-util"));
class WebSocketUrlBuilderImpl {
    constructor() {
        this.wsUrlTemplate = 'wss://%s:%d%s';
        this.httpsProtocolPrefix = 'https://';
        this.emptyPathname = '/';
    }
    static getNewInstance() {
        return new this();
    }
    setUrl(url) {
        try {
            this.url = new URL(url);
        }
        catch (err) {
            this.url = new URL(this.httpsProtocolPrefix + url);
        }
        return this;
    }
    setPort(port) {
        this.port = port;
        return this;
    }
    setDefaultPathname(pathname) {
        const regExp = new RegExp(`^${this.emptyPathname}`);
        this.defaultPathname = regExp.test(pathname) ? pathname : this.emptyPathname + pathname;
        return this;
    }
    build() {
        this.checkRequired();
        return (0, format_util_1.default)(this.wsUrlTemplate, 
        // @ts-ignore
        this.url.hostname, 
        // @ts-ignore
        this.url.port || this.port, 
        // @ts-ignore
        this.url.pathname !== this.emptyPathname ? this.url.pathname : this.defaultPathname);
    }
    checkRequired() {
        if (this.url === undefined) {
            throw new Error('An url is not set');
        }
        if (this.port === undefined) {
            throw new Error('A port is not set');
        }
        if (this.defaultPathname === undefined) {
            throw new Error('A default path name is not set');
        }
    }
}
exports.WebSocketUrlBuilderImpl = WebSocketUrlBuilderImpl;
//# sourceMappingURL=data:application/json;base64,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